import TagsUFs from 'govbr.frontend.policy/components/TagsUFs';

import styles from './Listing.module.less';
import {
  Category,
  Description,
  Subtitle,
  Thumbnail,
  Title,
} from './ListingParts';

export const NewsItem = ({ item, isEditMode }) => {
  const {
    Subject: tags,
    category_title: category,
    subtitle,
    uf_noticia,
    alt,
  } = item;

  return (
    <div className={styles.body}>
      <Subtitle subtitle={subtitle} />
      <Title item={item} isEditMode={isEditMode} />
      <Thumbnail item={item} isEditMode={isEditMode} alt={alt} />
      <Description item={item} />
      <Category category={category} />
      <TagsUFs
        className={'mt-1 mt-sm-0'}
        content={{
          subjects: tags,
          uf_noticia: uf_noticia?.map((item) => ({
            title: typeof item === 'string' ? item : item?.title || item,
          })),
        }}
      />
    </div>
  );
};
